import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import Select from 'react-select';
import { TimeRangePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
];

const SearchForm = (props) => {
    var formData = {
        timeOffset: '',
        searchStartDate: '',
        searchEndDate: '',
        ip_address: ''
    };

    const [dateState, setDateState] = useState({
        startDate: dayjs().startOf('day'),
        endDate: dayjs().endOf('day')
    });

    const [selectedOption, setSelectedOption] = useState(null);

    var current_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var current_index = 0;
    if(selectedOption) {
        current_index = props.timeZone.findIndex(obj => obj.label === selectedOption.label);
    } else {
        current_index = props.timeZone.findIndex(obj => obj.label === current_timezone);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(dateState){
            if(dateState.startDate) {
                var start_date = new Date(dateState.startDate).toLocaleString("en-GB");
                var split_start_data = start_date.split(", ");

                const [day, month, year] = split_start_data[0].split('/');

                const formattedStartDate = `${year}-${month}-${day} ${split_start_data[1]}`;
                formData.searchStartDate = formattedStartDate;
            }
            if(dateState.endDate) {
                var end_date = new Date(dateState.endDate).toLocaleString("en-GB");
                var split_end_data = end_date.split(", ");
                
                const [day, month, year] = split_end_data[0].split('/');

                const formattedEndDate = `${year}-${month}-${day} ${split_end_data[1]}`;
                formData.searchEndDate = formattedEndDate;
            }
        }
        const form_data = new FormData(event.target);
        formData.timeOffset = form_data.get('timezone');
        formData.ip_address = form_data.get('ip_address');
        
        props.searchReport(formData);
    }

    const handelTimezone = (selectedOption) => {
        setSelectedOption(selectedOption)
    }
   
    const onRangeChange = (dates, dateStrings) => {
        if (dates) {
            setDateState((prevState)=>{
                return {
                    ...prevState,
                    startDate: dates[0],
                    endDate: dates[1]
                }
            })
        } else {
            setDateState((prevState)=>{
                return {
                    ...prevState,
                    startDate: null,
                    endDate: null
                }
            })
        }
    };

    return (
        <div className='row mb-5'>
            <div className='col-md-12'>
                <div className='card'>
                    <div className='card-body p-5'>
                        <form onSubmit={handleSubmit}>
                            <div className='row'>
                                <div className='col-md-3 mb-5'>
                                    <Select 
                                        className='react-select-styled react-select-solid' 
                                        classNamePrefix='react-select' 
                                        placeholder='Select a Timezone' 
                                        name="timezone"
                                        options={props.timeZone}
                                        onChange={handelTimezone}
                                        value={props.timeZone[current_index]}
                                    />
                                </div>
                                <div className='col-md-5 mb-5'>
                                    <RangePicker
                                        presets={[
                                            {
                                                label: <span aria-label="Current Time to End of Day">Today</span>,
                                                value: () => [dayjs().startOf('day'), dayjs().endOf('day')],
                                            },
                                            ...rangePresets,
                                        ]}
                                        defaultValue={[dateState.startDate, dateState.endDate]}
                                        showTime
                                        format="YYYY-MM-DD HH:mm"
                                        onChange={onRangeChange}
                                        allowClear={false}
                                    />
                                </div>
                                <div className='col-md-3 mb-5'>
                                    <input
                                        type="text"
                                        className='form-control form-control-solid'
                                        placeholder="Enter IP Address"
                                        name='ip_address'
                                    />
                                </div>
                                <div className='col-md-1 text-end mt-1'>
                                    <button type="submit" className="btn btn-primary btn-icon btn-sm">
                                        {!props.loaderStatus && <FontAwesomeIcon icon={faMagnifyingGlass} />}

                                        {props.loaderStatus && <FontAwesomeIcon icon={faSpinner} spin className="me-2" />}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchForm;